import React from 'react';
import styled from 'styled-components';

import { TestimonalItem } from '../Testimonals/Testimonals';

import { Container } from '@/components/Container';
import { WhyBlockLayout } from '@/components/Layouts/WhyBlockLayout';
import Section from '@/components/Section/Section';
import { devices } from '@/styles/breakpoints';
import { RegularText, TitleH2 } from '@/styles/typography';

export const WhyIs = ({ leftSide, rightSide }) => {
  return (
    <WhyBlockLayout>
      <Container>
        <Section>
          <Content>
            <DescriptionBlock>
              <Title>{leftSide.title}</Title>
              {leftSide.items.map((item, idx) => (
                <RegularText key={idx}>{item.text}</RegularText>
              ))}
            </DescriptionBlock>
            <ReviewsBlock>
              <TestimonalItem item={rightSide} />
            </ReviewsBlock>
          </Content>
        </Section>
      </Container>
    </WhyBlockLayout>
  );
};

const Title = styled(TitleH2)`
  margin-bottom: 16px;
  text-align: left;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media only screen and ${devices.desktop} {
    flex-direction: row;
    gap: 56px;

    padding: 40px 0;
  }
`;

const DescriptionBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const ReviewsBlock = styled.div`
  width: 100%;
`;
